export class CookieConstants {
  static readonly agreement = "agreement";
}
